module.exports = __webpack_public_path__ + "static/media/2.d1894469.jpg";